import { render, staticRenderFns } from "./Catcher.vue?vue&type=template&id=b0b72eb8&"
import script from "./Catcher.vue?vue&type=script&lang=js&"
export * from "./Catcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports